import React from 'react'

import BasePureContainer from 'utils/BasePureContainer'

import Header from './components/Header'
import SideBar from './components/SideBar'

import './index.scss'

export default class Dashboard extends BasePureContainer {
  render() {
    return (
      <div id="Dashboard">
        <Header />
        <section className="Dashboard__container d-inline-flex">
          <SideBar className="Dashboard__container__sidebar" />
          <div className="Dashboard__container__content">
            {this.props.children}
          </div>
        </section>
        { this._renderModal() }
        { this._renderSecondModal() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js